import React, { Fragment, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { MAX_TASK_STEP_COUNT } from '../../../../constants/constants';
import InputText from '../../../Common/InputText';

import './CreateTaskForm.scss';

//#TODO ADD CIRCLE ICON
interface StepsComponentProps {
	currentTask: object;
	onFormChange: Function;
}

export const StepsComponentForm = ({ currentTask, onFormChange }: StepsComponentProps) => {
	const [editStep, setEditStep] = useState<boolean>(false);

	const getListStyle = (isDraggingOver) => ({
		background: isDraggingOver ? '#eee' : 'white',
		borderRadius: '0.25rem',
	});

	// tried moving this to scss but it just gets overridden from within the component
	const getItemStyle = (isDragging, draggableStyle) => ({
		userSelect: 'none',
		lineHeight: 1,
		margin: `0 0 8px 0`,
		background: 'white',
		border: isDragging ? '2px solid #03a9f4' : '',
		// styles we need to apply on draggables
		...draggableStyle,
	});

	const onDragEnd = (result) => {
		// dropped outside the step list area
		if (!result.destination) {
			return;
		}

		const steps = Array.from(currentTask.steps);
		const [removed] = steps.splice(result.source.index, 1);

		steps.splice(result.destination.index, 0, removed);

		// it could move up or down in the array, only update the ones needed
		const updateStartIndex = result.destination.index > result.source.index ? result.source.index : result.destination.index;

		// update the ordinal of any other steps after it in the array
		for (let i = updateStartIndex; i < steps.length; i++) {
			steps[i].ordinal = i;
		}
		onFormChange('steps', steps);
	};

	const onUpdateStepName = (step, e) => {
		let steps = currentTask.steps.slice();
		const index = steps.findIndex((x) => x.ordinal === step.ordinal);
		step.name = e.target.value;
		steps.splice(index, 1, step);
		onFormChange('steps', steps);
	};

	const onRemoveStep = (step) => {
		const steps = currentTask.steps.slice();
		const index = steps.findIndex((x) => x.ordinal === step.ordinal);
		// removing it from this array will mark it IsActive = false on the server during save (if it existed in the db)
		steps.splice(index, 1);
		// update the ordinal of any other steps after it in the array
		for (let i = index; i < steps.length; i++) {
			steps[i].ordinal = i + 1;
		}
		onFormChange('steps', steps);
	};

	const onAddStep = () => {
		const steps = [...currentTask.steps];

		const nextOrdinal = steps.length > 0 ? steps[steps.length - 1].ordinal + 1 : 1;

		const newStep = {
			id: 0,
			name: '',
			isActive: false,
			ordinal: nextOrdinal,
			baselineTaskId: currentTask.id,
		};

		steps.push(newStep);

		onFormChange('steps', steps);
		setEditStep(true);
	};

	const editCompleted = () => {
		setEditStep(false);
	};

	return (
		<div className='col-12'>
			<ul className='list-group'>
				<li className='step-header list-group-item d-flex justify-content-between align-items-center'>
					Step Details
					{currentTask.steps?.length < MAX_TASK_STEP_COUNT ? (
						<button type='button' className='btn btn-link' onClick={onAddStep}>
							<i className='fa-regular fa-circle-plus'></i>
							<span className='mx-1'>Add Step</span>
						</button>
					) : (
						''
					)}
				</li>
				<DragDropContext onDragEnd={onDragEnd}>
					<Droppable droppableId='droppable'>
						{(provided, snapshot) => (
							<div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
								{currentTask.steps?.map((step, index) => (
									<Draggable key={step.ordinal} draggableId={step.ordinal} index={index}>
										{(provided, snapshot) => (
											<Fragment>
												<div
													className='list-group-item d-flex justify-content-between align-items-center'
													ref={provided.innerRef}
													{...provided.draggableProps}
													{...provided.dragHandleProps}
													style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
													<div className='col-1'>
														<div className='task-step-bars'>
															<div className='icon-black custom-size-sup'>
																<span className='fa fa-bars'></span>
															</div>
														</div>
													</div>
													<div
														className='col-10'
														style={{
															fontSize: '13px',
															marginTop: editStep ? '10px' : '0',
														}}>
														{editStep ? (
															<InputText
																className='custom-size-sup'
																name={`stepname${index + 1}`}
																label='Name'
																type='text'
																placeholder='Name'
																value={step.name}
																onClick={() => console.log('test')}
																isRequired={true}
																errorMessage='Name Required'
																onChange={(e) => onUpdateStepName(step, e)}
																maxLength={100}
															/>
														) : (
															step.name
														)}
													</div>
													<div className='col-1 step-footer'>
														{editStep ? (
															<div className='icon-black custom-size-sup' onClick={editCompleted}>
																<i class='fa-regular fa-check'></i>
															</div>
														) : (
															<div className='icon-black custom-size-sup' onClick={() => setEditStep(!editStep)}>
																<i className='fa-light fa-pen-to-square'></i>
															</div>
														)}
														<div className='icon custom-size-sup' onClick={() => onRemoveStep(step)}>
															<span className='fa-light fa-trash-can'></span>
														</div>
													</div>
												</div>
											</Fragment>
										)}
									</Draggable>
								))}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
			</ul>
		</div>
	);
};
